import { applyTokens } from "../../../utilities/applyTokens.js";
const badge = (tokens) => {
    const { badge } = tokens.component;
    const { primary, secondary, tertiary } = badge.counter;
    return {
        MuiBadge: {
            defaultProps: {},
            styleOverrides: {
                badge: Object.assign(Object.assign({}, applyTokens(badge.counter.large)), applyTokens(badge.counter.large.label)),
                colorPrimary: Object.assign({}, applyTokens(primary)),
                colorSecondary: Object.assign({}, applyTokens(secondary)),
                colorNew: Object.assign({}, applyTokens(tertiary)),
            },
        },
    };
};
export default badge;
//# sourceMappingURL=badge.js.map